import ProductDetailComponent from '../components/product-detail/productDetail'

const ProductDetail = () => <ProductDetailComponent />

export default ProductDetail;